import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const SectionCalendarLazy = React.lazy(
	() => import(/* webpackChunkName : 'CalendarsLazy' */ './components')
);

export default (store) => {
	return {
		path: 'class-view/:campusId/:calendarId',
		element: <AsyncLoading component={<SectionCalendarLazy />} />,
		children: [],
	};
};
